// import { Constants } from './constants';

export class ReusableClasses {
    commonConstantHigher: number = 5000;
    encryptionKey = '123456$#@$^@1ERF';
    decryptionKey = '123456$#@$^@1ERF';
    constructor() {

    }

    //SUMMARY 
    //This function will return the unique collection from the collection list on the basis of unique CollectioID
    getUniqueValuesFromArray(array) {
        let unique = {};
        let distinct = [];
        for (var i in array) {
            if (typeof (unique[array[i].moduleRoute]) == "undefined") {
                distinct.push(array[i]);
            }
            unique[array[i].moduleRoute] = 0;
        }
        return distinct;
    }

    //SUMMARY
    //This function will return the month name from a particular date
    getMonthName(dt) {
        let mlist = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return mlist[dt.getMonth()];
    };

    //SUMMARY
    //This function is used to get the first date of the month.
    getFirstDateOfMonth() {
        let date = new Date();
        let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        //let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return firstDay;
    }

    //SUMMARY
    //This function is used to get the string of the date.
    changeDateToString(requestDate) {
        var dd = requestDate.getDate();
        var mm = requestDate.getMonth() + 1;
        var yyyy = requestDate.getFullYear();
        let temp = yyyy + '-' + (mm < 10 ? '0' + mm.toString() : mm) + '-' + (dd < 10 ? '0' + dd.toString() : dd);
  
        return temp;
     }

     convertIntoRighString(strDate:string){
        var dateArray=strDate.split("-");
        let year=dateArray[0];
        let monthCount=dateArray[1];
        let date=dateArray[2];
        
        var month = new Array();
        month[0] = "Jan";
        month[1] = "Feb";
        month[2] = "Mar";
        month[3] = "Apr";
        month[4] = "May";
        month[5] = "Jun";
        month[6] = "Jul";
        month[7] = "Aug";
        month[8] = "Sep";
        month[9] = "Oct";
        month[10] = "Nov";
        month[11] = "Dec";
        
        let monthName=month[(parseInt(monthCount)-1)];
        let newDateString=monthName+" "+date+", "+year;
        return newDateString;
     }

     reverseArr(input) {
        var ret = new Array;
        for (var i = input.length - 1; i >= 0; i--) {
          ret.push(input[i]);
        }
        return ret;
      }

      generateRandomString(possible: string) {
        let lengthOfCode = 40;
        let text = "";
        for (let i = 0; i < lengthOfCode; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
          return text;
      }
      
}
